import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEprPackagingType implements BaseEnumType {
  private static allValues: EnumEprPackagingType[] = []; // make sure this is top-most
  
  public static commonPublicBin = new EnumEprPackagingType(0, "CommonPublicBin", "enum_epr_packaging_type_common_public_bin");
  public static householdOrNonHousehold = new EnumEprPackagingType(1, "HouseholdOrNonHousehold", "enum_epr_packaging_type_household_or_non_household");
  public static drinksContainer = new EnumEprPackagingType(2, "DrinksContainer", "enum_epr_packaging_type_drinks_container");
  public static reusable = new EnumEprPackagingType(3, "Reusable", "enum_epr_packaging_type_reusable");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEprPackagingType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isCommonPublicBin() { return this === EnumEprPackagingType.commonPublicBin; }
  public isHouseholdOrNonHousehold() { return this === EnumEprPackagingType.householdOrNonHousehold; }
  public isDrinksContainer() { return this === EnumEprPackagingType.drinksContainer; }
  public isReusable() { return this === EnumEprPackagingType.reusable; }

  public static getValues(): readonly EnumEprPackagingType[] {
    return EnumEprPackagingType.allValues;
  }

  public static getValuesExcept0(): readonly EnumEprPackagingType[] {
    return EnumEprPackagingType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEprPackagingType {
    const found = EnumEprPackagingType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEprPackagingType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEprPackagingType): EnumEprPackagingType {
    const found = name ? EnumEprPackagingType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEprPackagingType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEprPackagingType>): boolean {
    return this.key === other?.key;
  }
}